import script from "./three-dimensional-works-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./three-dimensional-works-icon.vue?vue&type=script&setup=true&lang=js"

import "./three-dimensional-works-icon.vue?vue&type=style&index=0&id=745fdb79&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745fdb79"]])

export default __exports__